/**
 * Host element selectors for the search widget
 */

export function getHostEl() {
  return (
    document.querySelector("#nexus-search-widget") ||
    document.querySelector(".nexus-search-widget") ||
    document.querySelector("[data-nexus-search]")
  );
}

export function getCalendarHostEl() {
  return (
    document.querySelector("#nexus-calendar-section") ||
    document.querySelector(".nexus-calendar") ||
    document.querySelector("[data-nexus-calendar]")
  );
}
